import React, { useState } from 'react';
import './room4.css';

const CORRECT_CODE = '1882';

const SafePuzzle = ({ onClose, onSolve }) => {
  const [input, setInput] = useState('');
  const [error, setError] = useState(false);
  const [solved, setSolved] = useState(false);

  const handleDigit = (digit) => {
    if (input.length >= 4) return;
    setInput((prev) => prev + digit);
    setError(false);
  };

  const handleClear = () => {
    setInput('');
    setError(false);
  };

  const handleSubmit = () => {
    if (input === CORRECT_CODE) {
      setSolved(true);
      setTimeout(() => {
        onSolve();
      }, 2000);
    } else {
      setError(true);
      setTimeout(() => {
        setError(false);
        setInput('');
      }, 800);
    }
  };

  return (
    <div className="puzzleoverlay" onClick={onClose}>
      <div
        className={`puzzlemodal safemodal ${error ? 'puzzleshake' : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="puzzleclose" onClick={onClose}>✕</button>

        <h2 className="puzzletitle">THE SAFE</h2>
        <p className="puzzlesubtitle">
       Every door remembers its beginning. the year this house first breathed
        </p>

        <div className="safedisplay">
          {Array.from({ length: 4 }).map((_, i) => (
            <span key={i} className="safedigit">
              {input[i] ? '●' : ''}
            </span>
          ))}
        </div>

        {!solved && (
          <>
            <div className="safekeypad">
              {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((d) => (
                <button key={d} className="safekey" onClick={() => handleDigit(d)}>
                  {d}
                </button>
              ))}
              <button className="safekey safekeyclear" onClick={handleClear}>C</button>
              <button className="safekey" onClick={() => handleDigit('0')}>0</button>
              <button className="safekey safekeyenter" onClick={handleSubmit}>↵</button>
            </div>

            {error && <p className="puzzleerror">The lock refuses to turn.</p>}
          </>
        )}

        {solved && (
          <div className="successmessage">
            <h3>The door swings open.</h3>
            <p>Inside, something has been waiting a long time to be found.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SafePuzzle;
